app.service("selectCity", function(cookie, geolocation, shopsDetails) {
	
	var $self, $cities, $findNearStoreBtn, $available, $shopsListBtn, $shopsMapBtn;
	var product, viewType='list';
	
	function findPositionAndShops(){
		geolocation.findPosition(function(position){
			$cities[0].selectedIndex = 0;
			setView();
			if(product){
				shopsDetails.load({
					product_id: $self.data('product'),
					onlyAvailable:$available.length && $available.is(':checked'),
					latitude:position.coords.latitude,
					longitude:position.coords.longitude
				},viewType);
			}else{
				shopsDetails.load({
					action:'get_shops_for_geolocation',
					latitude:position.coords.latitude,
					longitude:position.coords.longitude
				},viewType);
			}
		});
	}
	function setView(view){
		if(typeof(view)==="undefined"){
			view=viewType;
		}else{
			viewType=view;
			$.scrollTo($('#search-city'));
		}
		$self.removeClass('shops-map shops-list');
		if(view=='map'){
			$self.addClass('shops-map');
		}else if(view=='list'){
			$self.addClass('shops-list');
		}
		shopsDetails.view(view);
	}
	function setSavedLocation() {
		var selectedShop = cookie.get('userCity');
		if(selectedShop && $cities.find('option[value='+selectedShop+']').length) {
			$cities.val(selectedShop);
			$cities.change();
		}
	}
	function findShopsWithProduct(city) {
		shopsDetails.load({
			city: city,
			product_id: $self.data('product'),
			onlyAvailable:$available.length && $available.is(':checked')
		},viewType);
	}
	function find(city) {
		if(city===''){
			$self.removeClass('shops-map shops-list');
		}else{
			cookie.set('userCity',city,{path:'/',expires:365});
			setView();
			if(product){
				findShopsWithProduct(city);
			}else{
				findShops(city);
			}
		}
	}
	function findShops(city) {
		shopsDetails.load({
			action:'get_shops',
			city_code:city
		},viewType);
	}
	function setElements() {
		$self = $('#search-city');
		$cities = $('#city-select', $self);
		if($self.length && $cities.length){
			$findNearStoreBtn = $('#find-near-store', $self);
			$available=$('#only-available', $self);
			$shopsListBtn = $('#switch-city-list', $self);
			$shopsMapBtn = $('#switch-city-map', $self);
			$cities[0].selectedIndex = 0;
			product=$self.data('product');
		}
	}
	function setEvents() {
		$findNearStoreBtn.on("click", findPositionAndShops);
		$shopsListBtn.on("click", function(){
			setView('list');
		});
		$shopsMapBtn.on("click", function(){
			setView('map');
		});
		$cities.on("change", function(){
			find($(this).val());
		});
		$available.on("click", function(){
			shopsDetails.available($(this).is(':checked'),viewType);
		});
		$('body').on('click', '.js-show-on-map', function() {
			setView('map');
		});
	}
	
	function init(product) {
		setElements();
		if($self.length){
			setEvents();
			shopsDetails.init(product);
			setSavedLocation();
		}
	}

	return {
		init: init
	};
});